module.exports = __webpack_public_path__ + "static/assets/afc6d3a65fb96f488ab7113f604cd108.gif";